import { ERC20 } from "@silo/typechain";
import { ethers } from "ethers";
import { ERC20_ABI } from "@silo/contract-utils";
import { ChecksumAddress, ClientProvider } from "@silo/types";

interface FetchAllowanceParams {
  assetAddress: ChecksumAddress;
  clientProvider: ClientProvider;
  account: ChecksumAddress;
  spender: ChecksumAddress;
}

export const fetchAllowance = async ({
  assetAddress,
  clientProvider,
  account,
  spender,
}: FetchAllowanceParams) => {
  const erc20Contract = <ERC20>(
    new ethers.Contract(assetAddress, ERC20_ABI, clientProvider)
  );

  const allowance = await erc20Contract.allowance(account, spender);

  return allowance.toBigInt();
};
